"use strict";
/**
 * Outpus device and browser information to the html element as class names
 */
document.addEventListener("DOMContentLoaded", function () {
    var deviceAgent = navigator.userAgent.toLowerCase();
    var htmlElement = document.querySelector("html");
    if (!htmlElement) {
        return;
    }
    if (deviceAgent.match(/(iphone|ipod|ipad)/)) {
        htmlElement.classList.add("ios");
        htmlElement.classList.add("mobile");
    }
    if (deviceAgent.match(/(Android)/)) {
        htmlElement.classList.add("android");
        htmlElement.classList.add("mobile");
    }
    if (navigator.userAgent.search("MSIE") >= 0) {
        htmlElement.classList.add("ie");
    }
    else if (navigator.userAgent.search("Chrome") >= 0) {
        htmlElement.classList.add("chrome");
    }
    else if (navigator.userAgent.search("Firefox") >= 0) {
        htmlElement.classList.add("firefox");
    }
    else if (navigator.userAgent.search("Safari") >= 0 &&
        navigator.userAgent.search("Chrome") < 0) {
        htmlElement.classList.add("safari");
    }
    else if (navigator.userAgent.search("Opera") >= 0) {
        htmlElement.classList.add("opera");
    }
});
